import React, { useState, useEffect, useRef } from 'react';
import './Contact.css';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    organization: '',
    message: ''
  });
  const [isMessageExpanded, setIsMessageExpanded] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);

  const sectionRef = useRef(null);
  const [wipeTriggered, setWipeTriggered] = useState(false);

  // One-shot trigger: when section top aligns with navbar bottom, fire the animation
  useEffect(() => {
    const getNavbarBottom = () => {
      const navbar = document.querySelector('.navbar');
      return navbar ? navbar.getBoundingClientRect().height : 90;
    };

    const handleScroll = () => {
      if (wipeTriggered || !sectionRef.current) return;
      const rect = sectionRef.current.getBoundingClientRect();
      const navbarBottom = getNavbarBottom();

      if (rect.top <= navbarBottom) {
        setWipeTriggered(true);
      }
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, [wipeTriggered]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleTrialRequest = () => {
    if (!formData.name || !formData.organization) {
      alert('Please fill in Name and Organization fields');
      return;
    }

    setIsSubmitting(true);
    const subject = encodeURIComponent(`Trial Request from ${formData.name}`);
    const body = encodeURIComponent(
      `Name: ${formData.name}\n` +
      `Organization: ${formData.organization}\n\n` +
      `Message: Trial Request`
    );

    const mailtoLink = `mailto:zhengtao.atomicarch@outlook.com?subject=${subject}&body=${body}`;
    window.location.href = mailtoLink;

    setTimeout(() => {
      setIsSubmitting(false);
      setSubmitStatus('success');
      setFormData({ name: '', organization: '', message: '' });
    }, 1000);
  };

  const handleCustomMessage = (e) => {
    e.preventDefault();
    if (!formData.name || !formData.organization || !formData.message) {
      alert('Please fill in all fields');
      return;
    }

    setIsSubmitting(true);
    const subject = encodeURIComponent(`Contact Form Submission from ${formData.name}`);
    const body = encodeURIComponent(
      `Name: ${formData.name}\n` +
      `Organization: ${formData.organization}\n\n` +
      `Message:\n${formData.message}`
    );

    const mailtoLink = `mailto:zhengtao.atomicarch@outlook.com?subject=${subject}&body=${body}`;
    window.location.href = mailtoLink;

    setTimeout(() => {
      setIsSubmitting(false);
      setSubmitStatus('success');
      setFormData({ name: '', organization: '', message: '' });
      setIsMessageExpanded(false);
    }, 1000);
  };

  return (
    <section id="contact" className={`contact-section ${wipeTriggered ? 'wipe-active' : ''}`} ref={sectionRef}>
      <div className="contact-container">
        <h1 className="contact-heading">Contact</h1>
        <form className="contact-form">
          <div className="form-group">
            <label htmlFor="name" className="form-label">Name</label>
            <input
              type="text"
              id="name"
              name="name"
              className="form-input"
              value={formData.name}
              onChange={handleChange}
              placeholder="Your name"
            />
          </div>

          <div className="form-group">
            <label htmlFor="organization" className="form-label">Organization</label>
            <input
              type="text"
              id="organization"
              name="organization"
              className="form-input"
              value={formData.organization}
              onChange={handleChange}
              placeholder="Your organization"
            />
          </div>

          <button
            type="button"
            className="trial-request-btn"
            onClick={handleTrialRequest}
            disabled={isSubmitting}
          >
            {isSubmitting ? 'Sending...' : 'Trial Request'}
          </button>

          <button
            type="button"
            className="toggle-message-btn"
            onClick={() => setIsMessageExpanded(!isMessageExpanded)}
          >
            {isMessageExpanded ? 'Hide Custom Message' : 'Send Custom Message'}
          </button>

          {isMessageExpanded && (
            <div className="message-section">
              <div className="form-group">
                <label htmlFor="message" className="form-label">Message</label>
                <textarea
                  id="message"
                  name="message"
                  className="form-textarea"
                  value={formData.message}
                  onChange={handleChange}
                  placeholder="Tell us about your project"
                  rows="6"
                />
              </div>

              <button
                type="button"
                className="submit-btn"
                onClick={handleCustomMessage}
                disabled={isSubmitting}
              >
                {isSubmitting ? 'Sending...' : 'Send Message'}
              </button>
            </div>
          )}

          {submitStatus === 'success' && (
            <p className="status-message success">Message sent successfully!</p>
          )}
          {submitStatus === 'error' && (
            <p className="status-message error">Failed to send message. Please try again.</p>
          )}
        </form>
      </div>
    </section>
  );
};

export default Contact;
